import React from 'react';
import Modal from "react-responsive-modal";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import { getlanguagelist } from "../../../helpers/changelanguage";

 

const customStyles = {
    width: '556px',
    position: 'relative'
  };
const WalletConnection = (props) => {
  const { modalOpen } = props;
  
 
  function closeModal(){
    //$("#otp").val('');
    $("#phonenumber").val('')
    props.closeModal();
  }
  const onSubmit = () => {
   
    props.evcpayment( $("#phonenumber").val());
    $("#phonenumber").val('');
    
  }
  const validNumber = () => {
    if (!Number($("#phonenumber").val())) {
      $("#phonenumber").val('')
    }
  }

  
  let  languagelist = getlanguagelist();
 
    return (
     
       
        <Modal open={modalOpen} onClose={closeModal} showCloseIcon={false} center>
          
       
          <div className="modal-header2">
            <button type="button" className="close" onClick={closeModal} ><img src="/assets/images/close_btn.png"/></button>
            
          </div>
          <div className="modal-body" style={customStyles}>
          
              <div className="col-lg-3">
                  <input maxLength="3" 
                    className="form-control"
                    placeholder={languagelist.emailotp}
                    name="countrycode"
                    id="countrycode" 
                    readOnly
                    value="252"
                  />
              </div>
                <div className="col-lg-9">
                  <input 
                    type="tel"
                    className="form-control"
                    placeholder="Enter your EVC Plus Number"
                    name="phonenumber"
                    id="phonenumber" 
                    pattern="[0-9]{10}" 
                    required 
                    onChange={validNumber}
                  />
                   <span className="pull-right">{/* <a onClick={() => resend('email')} style={{cursor : 'pointer'}}>Resend</a> */}&nbsp;   </span> 
                </div>
                
             
            
          </div>
          <div className="modal-footer">
            <input type="button" className="otp_btn" value="Pay" onClick={onSubmit}/>
          </div>
          
        

      </Modal>
    
    );
}
export default WalletConnection;